import cn from 'classnames';
import { isMobile } from 'react-device-detect';
// Hooks
import { useGetAllHomePageData } from 'hooks/useGetAllHomePageData';
import { useExtTalentCtaTracking } from 'hooks/useExtTalentCtaTracking';
// Layouts
import Main from 'layouts/Main/Main';
// Components
import NoAnimationHomePage from './NoAnimationHomePage';
import DesktopHomePage from './DesktopHomePage';
// Helpers
import { getCardsData } from './helpers/SlideHelper';
// Styles
import styles from './HomePage.module.scss';

const HomePage = () => {
  useExtTalentCtaTracking();
  const { data } = useGetAllHomePageData();

  const getData = (field: string) =>
    data?.getHomePageData?.[`${field}`]
      ?.slice()
      ?.sort((a, b) => a?.orderIndex - b?.orderIndex) || [];

  const banners = getData('mainBanners');
  const cardsData = getCardsData();

  return (
    <div className={styles.mobileSafeArea}>
      <Main
        className={cn(
          isMobile ? styles.homePageWrapper : styles.animationHomePageWrapper
        )}
        backgroundColor="background-main"
        withoutSidesPadding
      >
        {!isMobile ? (
          <DesktopHomePage
            banners={banners}
            cardsData={cardsData}
            featuredStreams={data?.featuredPpvEvents || []}
          />
        ) : (
          <NoAnimationHomePage
            banners={banners}
            cardsData={cardsData}
            featuredStreams={data?.featuredPpvEvents || []}
          />
        )}
      </Main>
    </div>
  );
};

export default HomePage;
